/**
 * Thai Translations for Commission Dashboard
 * ไฟล์แปลภาษาไทยสำหรับระบบติดตามค่าคอมมิชชั่น
 */

export const TH_TRANSLATIONS = {
  // Navigation & Layout
  navigation: {
    commission: "ค่าคอมมิชชั่น",
    dashboard: "แดชบอร์ด",
    commissionRates: "อัตราค่าคอมมิชชั่น",
    salesAnalytics: "การวิเคราะห์ยอดขาย",
    overview: "ภาพรวม",
    customerPortfolio: "พอร์ตลูกค้า",
    rfmAnalysis: "การวิเคราะห์ RFM",
    settings: "การตั้งค่า",
    production: "การผลิต",
    productionOverview: "ภาพรวมการผลิต",
    productionPerformance: "การเปรียบเทียบประสิทธิภาพ",
    productionMachines: "การทำงานของเครื่อง",
    productionPeople: "การทำงานของพนักงาน",
  },

  // Production
  production: {
    subtitle: "ข้อมูลการผลิตสติกเกอร์",
    comingSoon: "เร็ว ๆ นี้",
    placeholder:
      "ส่วนนี้อยู่ระหว่างการพัฒนา จะแสดงข้อมูลงานผลิต วัตถุดิบ และประสิทธิภาพเครื่องจักร",
    log: {
      title: "บันทึกการผลิตวันนี้",
      empty: "ไม่มีข้อมูลการผลิตในช่วงเวลานี้",
      loading: "กำลังโหลดข้อมูล...",
      error: "ไม่สามารถโหลดข้อมูลได้",
      columns: {
        time: "เวลา",
        employee: "พนักงาน",
        process: "กระบวนการ",
        machine: "เครื่อง",
        task: "เลขที่งาน",
        customer: "ลูกค้า",
        quantity: "จำนวนดวง",
        targetQuantity: "จำนวนสั่งผลิต",
        shots: "จำนวน shot",
        source: "ที่มา",
      },
      source: {
        production_log: "บันทึกผลิต",
        qc_pack: "QC/แพ็ค",
      },
      sourceTooltip: {
        production_log:
          "พนักงานบันทึกจำนวนผลิตเข้าระบบในแต่ละกระบวนการ (พิมพ์สี, ปั้มมีด, QC, สลิดขอบข้าง)",
        qc_pack: "การตรวจสอบขั้นสุดท้ายก่อนส่งมอบ (ตรวจสอบ)",
      },
      stats: {
        totalEvents: "จำนวนรายการ",
        uniqueEmployees: "พนักงานที่ทำงาน",
        uniqueTasks: "จำนวนงานที่ผลิต",
      },
    },
    filters: {
      datePickerLabel: "เลือกวันที่",
      today: "วันนี้",
      refresh: "รีเฟรช",
    },
    performance: {
      title: "การเปรียบเทียบประสิทธิภาพตามกระบวนการ",
      subtitle: "เปรียบเทียบผลงานของพนักงานในแต่ละกระบวนการ",
      empty: "ไม่มีข้อมูลในช่วงเวลานี้",
      loading: "กำลังโหลด...",
      error: "ไม่สามารถโหลดข้อมูลได้",
      metric: {
        label: "เกณฑ์การวัด",
        goodUnits: "จำนวนดวง",
        events: "จำนวนครั้ง",
        shots: "จำนวน shot",
        value: "มูลค่า",
        paperLength: "ความยาวกระดาษ (ม.)",
        paperArea: "พื้นที่กระดาษ (ตร.ม.)",
      },
      window: {
        label: "ช่วงวันที่",
        today: "วันนี้",
        last7Days: "7 วันที่ผ่านมา",
        last14Days: "14 วันที่ผ่านมา",
        last30Days: "30 วันที่ผ่านมา",
        custom: "กำหนดเอง",
      },
      stats: {
        totalProcesses: "จำนวนกระบวนการ",
        totalEmployees: "พนักงานทั้งหมด",
      },
      chart: {
        yAxisGoodUnits: "ชิ้น",
        yAxisEvents: "ครั้ง",
        yAxisShots: "Shot",
        tooltip: "{employee}: {value}",
      },
      viz: {
        label: "รูปแบบการแสดงผล",
        tabs: {
          smallMultiples: "แผนภูมิแท่งแยก",
          heatmap: "ฮีตแมป",
          dotPlot: "จุดกระจาย",
          rankedList: "รายการจัดอันดับ",
        },
        heatmap: {
          title: "ตารางความร้อน: พนักงาน × กระบวนการ",
          legend:
            "สีบอกว่าผลงานวันนี้ของคนนี้ สูงหรือต่ำกว่าค่าเฉลี่ยปกติของงานนั้นแค่ไหน (ไม่ใช่ตัวเลขดิบ)",
          employeeCol: "พนักงาน",
          avgCol: "เฉลี่ย",
          legendLabel: "เปรียบเทียบกับค่าเฉลี่ย",
          noData: "ไม่มีข้อมูล",
          nTooSmall: "ข้อมูลน้อยเกินไป จึงเปรียบเทียบไม่ได้",
          machineSplitLabel: "แยกตามเครื่อง",
          machineSplitOn: "เปิด",
          machineSplitOff: "ปิด",
          baselineLabel: "เปรียบเทียบกับค่าเฉลี่ยย้อนหลัง 30 วัน",
          baselineLoading: "กำลังโหลดข้อมูลย้อนหลัง...",
          zLegendLabel: "สีเทียบกับค่าเฉลี่ยย้อนหลัง 30 วัน",
          zBandCriticallyLow: "ต่ำกว่าปกติมาก",
          zBandLow: "ต่ำกว่าปกติ",
          zBandNormal: "ปกติ",
          zBandHigh: "สูงกว่าปกติ",
          zBandCriticallyHigh: "สูงกว่าปกติมาก",
          insufficientBaseline: "ข้อมูลย้อนหลังน้อยเกินไป จึงไม่แสดงสี",
          rowMachineSuffix: "@ {machine}",
          tooltipCurrent: "ผลงานวันนี้",
          tooltipOwnBaseline: "ค่าเฉลี่ยของคนนี้ย้อนหลัง 30 วัน",
          tooltipDelta: "ต่างจากค่าเฉลี่ยของตนเอง",
          tooltipPeerBaseline: "ค่าเฉลี่ยของคนอื่นที่ทำงานนี้",
        },
        dotPlot: {
          title: "แผนภูมิจุดกระจาย: เปรียบเทียบกับค่าเฉลี่ยของแต่ละงาน",
          legend:
            "แต่ละจุดคือพนักงาน 1 คนในงาน 1 อย่าง — จุดทางซ้าย = ทำได้น้อยกว่าค่าเฉลี่ย, จุดทางขวา = ทำได้มากกว่าค่าเฉลี่ย",
          xAxisLabel:
            "เทียบกับค่าเฉลี่ยของงานนี้ (ซ้าย = ต่ำกว่า, ขวา = สูงกว่า)",
          zScoreLabel: "ค่าเปรียบเทียบ",
        },
        rankedList: {
          title: "จัดอันดับพนักงานตามผลงานเฉลี่ย",
          legend:
            "อันดับจากต่ำไปสูง (อันดับ 1 = ผลงานต่ำที่สุดเมื่อเทียบกับคนอื่น)",
        },
      },
      legend: {
        title: "วิธีอ่านสี",
        intro: "สีเทียบผลงานของคนนี้กับค่าเฉลี่ยย้อนหลัง 30 วัน",
        criticallyLow: "ต่ำกว่าปกติมาก",
        low: "ต่ำกว่าปกติ",
        normal: "ปกติ",
        high: "สูงกว่าปกติ",
        criticallyHigh: "สูงกว่าปกติมาก",
        noData: "ไม่มีข้อมูล",
      },
      caveat:
        "หมายเหตุ: ผลงานที่ต่ำอาจเกิดจากชั่วโมงการทำงาน, ประเภทงานที่ได้รับ, หรือการแบ่งกะที่ต่างกัน ไม่ได้แปลว่าผลิตช้ากว่าคนอื่นเสมอไป",
    },
    shotsCaveat:
      "Shot = ceil(ชิ้น / (l×w)) สำหรับเครื่องพิมพ์, หรือ ceil(ชิ้น / knifeCount) สำหรับเครื่องปั้มมีด",
    machines: {
      title: "การทำงานของเครื่องจักร",
      subtitle: "ภาพรวมปริมาณการผลิตของแต่ละเครื่องตามวัน",
      empty: "ไม่มีข้อมูลในช่วงเวลานี้",
      error: "ไม่สามารถโหลดข้อมูลได้",
      loading: "กำลังโหลด...",
      caveat:
        "สีแสดง z-score เทียบกับ baseline ของแต่ละเครื่อง สีแดง = ต่ำกว่าค่าเฉลี่ยของตัวเอง, สีเขียว = สูงกว่า. เซลล์ว่าง = ไม่มีงานในวันนั้น",
      metric: {
        label: "เกณฑ์การวัด",
        goodUnits: "จำนวนดวง",
        shots: "จำนวน shot",
        value: "มูลค่า",
        paperLength: "ความยาวกระดาษ (ม.)",
        paperArea: "พื้นที่กระดาษ (ตร.ม.)",
      },
      window: {
        label: "ช่วงเวลา",
        today: "วันนี้",
        last7Days: "7 วัน",
        last14Days: "14 วัน",
        last30Days: "30 วัน",
      },
      stats: {
        totalMachines: "จำนวนเครื่อง",
        totalEvents: "จำนวนรายการ",
        avgActiveDays: "วันทำงานเฉลี่ย",
        totalShots: "จำนวน shot รวม",
        totalValue: "มูลค่ารวม",
        totalPaperLength: "ความยาวกระดาษรวม",
        totalPaperArea: "พื้นที่กระดาษรวม",
      },
      table: {
        machineCol: "เครื่อง",
        totalCol: "รวม",
        operatorsCol: "ผู้ควบคุม",
        activeDaysCol: "วันที่ทำงาน",
        emptyDay: "ไม่มีงาน",
        sumRow: "รวมต่อวัน",
      },
      drill: {
        titleDay: "รายการงานวันที่ {day} · เครื่อง {machine}",
        titleTotal: "รายการงานทั้งหมด · เครื่อง {machine}",
        empty: "ไม่มีรายการ",
        col: {
          task: "เลขที่งาน",
          stage: "กระบวนการ",
          operator: "พนักงาน",
          time: "เวลา",
          qty: "จำนวนผลิต",
          waste: "จำนวนผลิตเสีย",
          targetQty: "จำนวนสั่งผลิต",
          overproduction: "จำนวนผลิตเกิน",
          shots: "shot",
          stageTotal: "รวมทั้งกระบวนการ",
          share: "สัดส่วน",
          invoice: "มูลค่างาน",
          value: "มูลค่าที่ได้",
        },
        summary: {
          rows: "จำนวนรายการ",
          totalQty: "จำนวนดวง",
          totalShots: "รวม shot",
          totalValue: "รวมมูลค่า",
          totalTasks: "จำนวนงาน",
          totalWaste: "รวมเสีย",
          totalTarget: "จำนวนสั่งผลิต",
          totalOverproduction: "จำนวนผลิตเกิน",
        },
        group: {
          operators: "{n} พนักงาน",
          subtotal: "รวมในรายการนี้",
          shareInTask: "สัดส่วนในงาน",
          overproduction: "ผลิตเกิน",
          targetQty: "จำนวนสั่งผลิต",
        },
        close: "ปิด",
      },
      tooltip: {
        machine: "เครื่อง",
        day: "วัน",
        goodUnits: "ผลิตได้",
        events: "รายการ",
        ownMean: "ค่าเฉลี่ยของเครื่อง",
        zScore: "Z-Score",
      },
      legend: {
        title: "วิธีอ่านสี",
        intro: "สีในตารางเปรียบเทียบผลผลิตกับค่าเฉลี่ยของเครื่องตัวเอง",
        criticallyLow: "ต่ำกว่าปกติมาก",
        low: "ต่ำกว่าปกติ",
        normal: "ปกติ",
        high: "สูงกว่าปกติ",
        criticallyHigh: "สูงกว่าปกติมาก",
        noData: "ไม่มีงาน",
      },
      detail: {
        backToList: "กลับไปหน้ารายการเครื่อง",
        title: "รายละเอียดเครื่อง: {machine}",
        loading: "กำลังโหลด...",
        error: "ไม่สามารถโหลดข้อมูลได้",
        window: {
          label: "ช่วงเวลา",
          today: "วันนี้",
          last14Days: "14 วัน",
          last30Days: "30 วัน",
          last60Days: "60 วัน",
          last90Days: "90 วัน",
        },
        stats: {
          totalGoodUnits: "จำนวนดวงรวม",
          activeDays: "วันทำงาน",
          uniqueOperators: "พนักงาน",
          uniqueTasks: "งาน",
          longestIdleGap: "ช่วงว่างนานสุด",
          totalShots: "จำนวน shot รวม",
          totalValue: "มูลค่ารวม",
        },
        sections: {
          throughputTrend: "แนวโน้มผลผลิตรายวัน",
          throughputTrendSubtitle:
            "จำนวนชิ้นต่อวัน พร้อมเส้นค่าเฉลี่ยในช่วงนี้",
          operatorMix: "พนักงานที่ใช้เครื่อง",
          operatorMixSubtitle: "จัดเรียงตามผลงาน",
          topJobs: "งานที่ผลิตมากที่สุด",
          topJobsSubtitle: "สูงสุด 20 งาน",
          idleGaps: "ช่วงเวลาว่าง (≥2 ชม.)",
          idleGapsSubtitle: "ช่องว่างระหว่างการทำงาน, สูงสุด 20 รายการ",
        },
        metric: {
          label: "เกณฑ์การวัด",
          goodUnits: "จำนวนดวง",
          shots: "จำนวน shot",
          value: "มูลค่า",
        },
        operatorTable: {
          name: "พนักงาน",
          goodUnits: "จำนวนดวง",
          events: "รายการ",
          daysActive: "วันที่ทำงาน",
          shots: "จำนวน shot",
          value: "มูลค่า",
          peerRank: "อันดับเทียบเพื่อน",
          soleOperator: "คนเดียว",
          insufficientBaseline: "ข้อมูลน้อย",
          zScoreTooltip: "Z-Score",
          noPeerComparison: "ไม่สามารถเทียบกับเพื่อนได้",
          soleOperatorBanner:
            "เครื่องนี้มีพนักงานควบคุมเพียงคนเดียวในช่วงเวลานี้ จึงไม่มีการเทียบกับเพื่อนร่วมงาน",
        },
        jobsTable: {
          taskNumber: "เลขที่งาน",
          customer: "ลูกค้า",
          goodUnits: "จำนวนดวง",
          events: "รายการ",
          duration: "ระยะเวลา",
          shots: "จำนวน shot",
          value: "มูลค่า",
          paperWidth: "หน้ากว้าง",
          paperLength: "ความยาวกระดาษ",
          targetQuantity: "จำนวนสั่งผลิต",
        },
        idleGapsTable: {
          start: "เริ่ม",
          end: "สิ้นสุด",
          duration: "ระยะเวลา",
        },
        empty: {
          machine: "ไม่มีข้อมูลเครื่องนี้ในช่วงเวลาที่เลือก",
          operators: "ไม่มีพนักงาน",
          jobs: "ไม่มีงาน",
          idleGaps: "ไม่พบช่วงเวลาว่าง",
        },
        format: {
          hourMinute: "{h} ชม. {m} นาที",
          minute: "{m} นาที",
        },
        legend: {
          title: "วิธีอ่านสี",
          intro: "สีเทียบผลผลิตแต่ละวันกับค่าเฉลี่ยของเครื่องในช่วงที่เลือก",
          criticallyLow: "ต่ำกว่าปกติมาก",
          low: "ต่ำกว่าปกติ",
          normal: "ปกติ",
          high: "สูงกว่าปกติ",
          criticallyHigh: "สูงกว่าปกติมาก",
          noData: "ไม่มีงาน",
        },
      },
    },
    people: {
      title: "การทำงานของพนักงาน",
      subtitle: "ภาพรวมปริมาณการผลิตของแต่ละพนักงานตามวัน",
      empty: "ไม่มีข้อมูลในช่วงเวลานี้",
      error: "ไม่สามารถโหลดข้อมูลได้",
      loading: "กำลังโหลด...",
      caveat:
        "สีในตารางเปรียบเทียบกับค่าเฉลี่ยของพนักงานคนนั้นเอง ไม่ใช่เทียบกับเพื่อนร่วมงาน การทำงานน้อยในบางวันอาจเกิดจากกะงาน, ประเภทงาน, หรือการลา ไม่ใช่ผลงานที่ช้า",
      unknownProcess: "ไม่ระบุกระบวนการ",
      metric: {
        label: "เกณฑ์การวัด",
        goodUnits: "จำนวนดวง",
        shots: "จำนวน shot",
        value: "มูลค่า",
        paperLength: "ความยาวกระดาษ (ม.)",
        paperArea: "พื้นที่กระดาษ (ตร.ม.)",
      },
      window: {
        label: "ช่วงเวลา",
        today: "วันนี้",
        last7Days: "7 วัน",
        last14Days: "14 วัน",
        last30Days: "30 วัน",
      },
      stats: {
        totalPeople: "จำนวนพนักงาน",
        totalEvents: "จำนวนรายการ",
        avgActiveDays: "วันทำงานเฉลี่ย",
        totalValue: "มูลค่ารวม",
      },
      table: {
        personCol: "พนักงาน",
        personMachineCol: "พนักงาน × เครื่อง",
        totalCol: "รวม",
        machinesCol: "เครื่อง",
        activeDaysCol: "วันที่ทำงาน",
        primaryShare: "งานหลัก",
        emptyDay: "ไม่มีงาน",
        operators: "พนักงาน",
        sumRow: "รวมต่อวัน",
      },
      group: {
        label: "จัดกลุ่มตาม",
        process: "งาน",
        machine: "เครื่อง",
      },
      tooltip: {
        person: "พนักงาน",
        machine: "เครื่อง",
        day: "วัน",
        goodUnits: "ผลิตได้",
        ownMean: "ค่าเฉลี่ยของตัวเอง",
        zScore: "Z-Score",
      },
      split: {
        label: "แยกตามเครื่อง",
        on: "เปิด",
        off: "ปิด",
      },
      legend: {
        title: "วิธีอ่านสี",
        intro:
          "สีในตารางเปรียบเทียบผลผลิตของวันนั้นกับค่าเฉลี่ยของพนักงานคนนั้นเอง",
        criticallyLow: "ต่ำกว่าปกติมาก",
        low: "ต่ำกว่าปกติ",
        normal: "ปกติ",
        high: "สูงกว่าปกติ",
        criticallyHigh: "สูงกว่าปกติมาก",
        noData: "ไม่มีงาน",
      },
      drill: {
        titleDay: "รายการงานวันที่ {day} · {name}",
        titleTotal: "รายการงานทั้งหมด · {name}",
        subtitleMachine: "เครื่อง: {machine}",
        empty: "ไม่มีรายการ",
        col: {
          task: "เลขที่งาน",
          stage: "กระบวนการ",
          machine: "เครื่อง",
          time: "เวลา",
          qty: "จำนวนที่คุณทำ",
          stageTotal: "รวมทั้งกระบวนการ",
          share: "สัดส่วน",
          invoice: "มูลค่างาน",
          value: "มูลค่าที่ได้",
        },
        summary: {
          rows: "จำนวนรายการ",
          totalQty: "จำนวนดวง",
          totalShots: "รวม shot",
          totalValue: "รวมมูลค่า",
        },
        close: "ปิด",
      },
      detail: {
        backToList: "กลับไปหน้ารายการพนักงาน",
        title: "พนักงาน: {name}",
        loading: "กำลังโหลด...",
        error: "ไม่สามารถโหลดข้อมูลได้",
        caveat:
          'ช่อง "อันดับเทียบเพื่อน" เทียบกับพนักงานคนอื่นที่ควบคุมเครื่องเดียวกัน (ต้องมี ≥3 ตัวอย่าง) หากเป็น "คนเดียว" หมายถึงไม่มีเพื่อนให้เทียบ ข้อมูลอื่น ๆ เป็นของตัวเอง',
        window: {
          label: "ช่วงเวลา",
          today: "วันนี้",
          last14Days: "14 วัน",
          last30Days: "30 วัน",
          last60Days: "60 วัน",
          last90Days: "90 วัน",
        },
        metric: {
          label: "เกณฑ์การวัด",
          goodUnits: "จำนวนดวง",
          shots: "จำนวน shot",
          value: "มูลค่า",
        },
        stats: {
          totalGoodUnits: "จำนวนดวงรวม",
          totalShots: "จำนวน shot รวม",
          totalValue: "มูลค่ารวม",
          activeDays: "วันทำงาน",
          uniqueMachines: "เครื่องที่ใช้",
          uniqueTasks: "งาน",
          longestIdleGap: "ช่วงว่างนานสุด",
        },
        sections: {
          throughputTrend: "แนวโน้มผลผลิตรายวัน",
          throughputTrendSubtitle:
            "จำนวนชิ้นต่อวัน พร้อมเส้นค่าเฉลี่ยของตัวเอง",
          machineRank: "อันดับต่อเครื่อง",
          machineRankSubtitle:
            "เทียบกับพนักงานคนอื่นบนเครื่องเดียวกัน (z-score)",
          processMix: "สัดส่วนกระบวนการ",
          processMixSubtitle: "แบ่งตามประเภทงาน",
          topJobs: "งานที่ทำมากที่สุด",
          topJobsSubtitle: "สูงสุด 20 งาน",
          idleGaps: "ช่วงเวลาว่าง (≥2 ชม.)",
          idleGapsSubtitle: "ช่องว่างระหว่างการทำงาน, สูงสุด 20 รายการ",
        },
        machineTable: {
          machine: "เครื่อง",
          primaryProcess: "งานหลัก",
          goodUnits: "จำนวนดวง",
          shots: "จำนวน shot",
          value: "มูลค่า",
          daysActive: "วันที่ทำงาน",
          rankOnMachine: "อันดับเทียบเพื่อน",
          soleOperator: "คนเดียว",
          insufficientBaseline: "ข้อมูลน้อย",
          zScoreTooltip: "Z-Score",
          noPeerComparison:
            "ไม่สามารถเทียบกับเพื่อนได้ (ข้อมูลน้อยหรือไม่มีเพื่อนร่วมงาน)",
        },
        processTable: {
          process: "กระบวนการ",
          goodUnits: "จำนวนดวง",
          shots: "จำนวน shot",
          value: "มูลค่า",
          events: "รายการ",
          daysActive: "วันที่ทำงาน",
        },
        jobsTable: {
          taskNumber: "เลขที่งาน",
          customer: "ลูกค้า",
          goodUnits: "จำนวนดวง",
          shots: "จำนวน shot",
          value: "มูลค่า",
          paperWidth: "หน้ากว้าง",
          paperLength: "ความยาวกระดาษ",
          targetQuantity: "จำนวนสั่งผลิต",
          events: "รายการ",
          duration: "ระยะเวลา",
        },
        idleGapsTable: {
          start: "เริ่ม",
          end: "สิ้นสุด",
          duration: "ระยะเวลา",
        },
        empty: {
          person: "ไม่มีข้อมูลพนักงานคนนี้ในช่วงเวลาที่เลือก",
          machines: "ไม่มีเครื่องที่ใช้",
          processes: "ไม่มีกระบวนการ",
          jobs: "ไม่มีงาน",
          idleGaps: "ไม่พบช่วงเวลาว่าง",
        },
        format: {
          hourMinute: "{h} ชม. {m} นาที",
          minute: "{m} นาที",
        },
        legend: {
          title: "วิธีอ่านสีช่องอันดับ",
          intro: "เทียบ z-score กับเพื่อนร่วมงานที่ใช้เครื่องเดียวกัน",
          criticallyLow: "ต่ำกว่าปกติมาก",
          low: "ต่ำกว่าปกติ",
          normal: "ปกติ",
          high: "สูงกว่าปกติ",
          criticallyHigh: "สูงกว่าปกติมาก",
          noData: "ไม่มีข้อมูล",
        },
      },
    },
  },

  // Common Actions
  actions: {
    refresh: "รีเฟรช",
    export: "ส่งออก",
    exportCSV: "ส่งออก CSV",
    exportExcel: "ส่งออก Excel",
    exportJSON: "ส่งออก JSON",
    save: "บันทึก",
    cancel: "ยกเลิก",
    delete: "ลบ",
    edit: "แก้ไข",
    create: "สร้าง",
    update: "อัปเดต",
    back: "ย้อนกลับ",
    backToDashboard: "กลับไปที่แดชบอร์ด",
    close: "ปิด",
    confirm: "ยืนยัน",
    dismiss: "ปิด",
    loading: "กำลังโหลด...",
    search: "ค้นหา",
    select: "เลือก",
  },

  // Dashboard Page
  dashboard: {
    title: "แดชบอร์ดค่าคอมมิชชั่น",
    subtitle: "ติดตามและวิเคราะห์ค่าคอมมิชชั่นของพนักงานขายตามรอบระยะเวลา",
    tableTitle: "สรุปค่าคอมมิชชั่นพนักงานขาย",

    // Table Headers
    table: {
      employee: "พนักงาน",
      invoiceCount: "จำนวนใบแจ้งหนี้",
      totalSales: "ยอดขายรวม",
      paidThisPeriod: "ชำระในรอบนี้",
      commissionable: "คำนวณค่าคอมมิชชั่น",
      nonComm: "ไม่มีค่าคอม (0%)",
      pendingCollection: "รอเก็บเงิน",
      creditNotes: "ใบลดหนี้",
      totalCommission: "ค่าคอมมิชชั่นรวม",
    },

    // Stats Cards
    stats: {
      salespersons: "พนักงานขาย",
      invoices: "ใบแจ้งหนี้",
      periodSales: "ยอดขายรอบนี้",
      paidInPeriod: "ชำระในรอบนี้",
      pendingCollection: "รอเก็บเงิน",
      commission: "ค่าคอมมิชชั่น",
    },

    // Status Cards
    status: {
      invoiceExclusionsActive: "มีการยกเว้นใบแจ้งหนี้",
      creditNotesApplied: "มีการใช้ใบลดหนี้",
      adminMode: "โหมดแอดมิน",
      preTaxDeduction: "หักก่อนภาษี",
    },

    // Messages
    messages: {
      selectDateRange: "กรุณาเลือกช่วงวันที่",
      exportSuccess: "ส่งออกสำเร็จ",
      exportSuccessMessage: "ไฟล์ {format} ถูกดาวน์โหลดแล้ว",
      exportFailed: "การส่งออกล้มเหลว",
      exportFailedMessage: "ไม่สามารถส่งออกข้อมูลค่าคอมมิชชั่นได้",
    },
  },

  // Admin Commission Rates Page
  adminRates: {
    title: "แอดมิน - อัตราค่าคอมมิชชั่น",
    subtitle: "จัดการอัตราค่าคอมมิชชั่นสำหรับพนักงานขายและสินค้า",

    // Buttons
    addDefaultRate: "เพิ่มอัตราเริ่มต้น",
    addCustomRate: "เพิ่มอัตราพิเศษ",

    // Dialog Titles
    editDefaultRate: "แก้ไขอัตราเริ่มต้น",
    addDefaultRateTitle: "เพิ่มอัตราเริ่มต้น",
    editCustomRate: "แก้ไขอัตราพิเศษ",
    addCustomRateTitle: "เพิ่มอัตราพิเศษ",

    // Form Labels
    skuPrefix: "คำนำหน้า SKU",
    commissionRate: "อัตราค่าคอมมิชชั่น (%)",
    description: "คำอธิบาย (ไม่บังคับ)",
    salesperson: "พนักงานขาย",

    // Placeholders
    skuPrefixPlaceholder: "เช่น ML, MFB, MC",
    ratePlaceholder: "เช่น 2.0",
    descriptionPlaceholder: "คำอธิบายสำหรับอัตรานี้...",
    selectSalesperson: "เลือกพนักงานขาย",
    searchSalesperson: "ค้นหาพนักงานขาย...",
    noSalespersonFound: "ไม่พบพนักงานขาย",
    selectSkuPrefix: "เลือกคำนำหน้า SKU",
    searchSkuPrefix: "ค้นหาคำนำหน้า SKU...",
    noSkuPrefixFound: "ไม่พบคำนำหน้า SKU",

    // Stats
    stats: {
      defaultRates: "อัตราเริ่มต้น",
      customRates: "อัตราพิเศษ",
      avgDefaultRate: "อัตราเฉลี่ยเริ่มต้น",
      avgCustomRate: "อัตราเฉลี่ยพิเศษ",
    },

    // Tabs
    tabs: {
      defaultRates: "อัตราเริ่มต้น",
      customRates: "อัตราพิเศษ",
    },

    // Table Headers
    table: {
      skuPrefix: "คำนำหน้า SKU",
      commissionRate: "อัตราค่าคอมมิชชั่น",
      description: "คำอธิบาย",
      created: "วันที่สร้าง",
      actions: "การดำเนินการ",
      salesperson: "พนักงานขาย",
    },

    // Empty States
    noDefaultRates: "ยังไม่มีการตั้งค่าอัตราเริ่มต้น",
    noCustomRates: "ยังไม่มีการตั้งค่าอัตราพิเศษ",

    // Confirmation Messages
    confirmDeleteDefault:
      "คุณแน่ใจหรือไม่ที่จะลบอัตราเริ่มต้นสำหรับ {skuPrefix}?",
    confirmDeleteCustom:
      "คุณแน่ใจหรือไม่ที่จะลบอัตราพิเศษสำหรับ {salespersonId} - {skuPrefix}?",

    // Error Messages
    errors: {
      fetchDefaultRates: "ไม่สามารถดึงข้อมูลอัตราเริ่มต้นได้",
      fetchCustomRates: "ไม่สามารถดึงข้อมูลอัตราพิเศษได้",
      saveDefaultRate: "ไม่สามารถบันทึกอัตราเริ่มต้นได้",
      deleteDefaultRate: "ไม่สามารถลบอัตราเริ่มต้นได้",
      saveCustomRate: "ไม่สามารถบันทึกอัตราพิเศษได้",
      deleteCustomRate: "ไม่สามารถลบอัตราพิเศษได้",
    },
  },

  // Sales Overview Page
  salesOverview: {
    title: "การวิเคราะห์ยอดขาย",
    subtitle: "ภาพรวมยอดขายและตัวชี้วัดประสิทธิภาพที่ครอบคลุม",

    stats: {
      totalRevenue: "รายได้รวม",
      totalProjects: "โครงการทั้งหมด",
      activeSalespersons: "พนักงานขายที่ใช้งาน",
      avgProjectValue: "มูลค่าเฉลี่ยต่อโครงการ",
      completedInvoices: "ใบแจ้งหนี้ที่เสร็จสมบูรณ์",
      withSalesThisPeriod: "มียอดขายในรอบนี้",
      perProject: "ต่อโครงการ",
    },

    charts: {
      salesTrend: "แนวโน้มยอดขายปีนี้",
      salesTrendDesc: "ความก้าวหน้ารายได้และการเติบโตรายเดือน",
      topCustomers: "ลูกค้าที่ใช้จ่ายมากที่สุด",
      topCustomersDesc: "ลูกค้าที่มีรายได้สูงสุดในรอบนี้",
      revenueByCategory: "รายได้ตามหมวดหมู่",
      revenueByCategoryDesc: "การกระจายยอดขายตามหมวดหมู่ผลิตภัณฑ์",
      periodComparison: "การเปรียบเทียบรอบระยะเวลา",
      periodComparisonDesc: "แนวโน้มรายได้เทียบกับรอบก่อนหน้า",
      revenueGrowth: "การเติบโตรายได้ตามหมวดหมู่",
      revenueGrowthDesc: "การเปลี่ยนแปลงรายได้รอบต่อรอบ",
      projectCountGrowth: "การเติบโตจำนวนโครงการตามหมวดหมู่",
      projectCountGrowthDesc: "การเปลี่ยนแปลงจำนวนโครงการรอบต่อรอบ",
      topProjects: "โครงการ 10 อันดับแรก",
      topProjectsDesc: "โครงการที่มีรายได้สูงสุดในรอบนี้",
    },
  },

  // Customers Overview Page
  customersOverview: {
    title: "ภาพรวมลูกค้า",
    subtitle: "การวิเคราะห์ลูกค้าทั่วโลกจากพนักงานขายทุกคน",

    stats: {
      totalCustomers: "ลูกค้าทั้งหมด",
      newCustomers: "ลูกค้าใหม่",
      retentionRate: "อัตราการรักษาลูกค้า",
      churnRate: "อัตราการสูญเสียลูกค้า",
      fromLastPeriod: "จากรอบที่แล้ว",
      ofTotal: "ของทั้งหมด",
      customerRetention: "การรักษาลูกค้า",
      customersChurned: "ลูกค้าที่สูญเสีย",
    },

    rfm: {
      title: "การแบ่งกลุ่มลูกค้า RFM",
      description:
        "ค้นหาว่าลูกค้าคนไหนต้องการความสนใจด้วยการวิเคราะห์ RFM ขั้นสูง",
      viewAnalysis: "ดูการวิเคราะห์",
      segments: "11 กลุ่มลูกค้า",
      segmentsDesc: "แชมเปี้ยน, มีความเสี่ยง, หลับใหล และอื่นๆ",
      insights: "ข้อมูลเชิงลึกที่นำไปปฏิบัติได้",
      insightsDesc: "กลยุทธ์ที่ปรับแต่งสำหรับแต่ละกลุ่ม",
      targeting: "การกำหนดเป้าหมายตามลำดับความสำคัญ",
      targetingDesc: "มุ่งเน้นโอกาสที่มีมูลค่าสูง",
    },

    atRisk: {
      title: "ลูกค้าที่มีความเสี่ยง",
      description: "ลูกค้าที่ไม่มีการซื้อล่าสุดซึ่งอาจต้องการการดูแลใหม่",
      inactive1Month: "ไม่ได้ซื้อภายใน 1 เดือน",
      inactive2Months: "ไม่ได้ซื้อภายใน 2 เดือน",
      inactive3Months: "ไม่ได้ซื้อภายใน 3 เดือน",
      inactive6Months: "ไม่ได้ซื้อภายใน 6 เดือน",
      clickToView: "คลิกเพื่อดูรายละเอียด",
    },

    topCustomers: {
      title: "ลูกค้าชั้นนำตามรายได้",
      description: "ลูกค้าที่ใช้จ่ายสูงสุดจากพนักงานขายทุกคน",
      customer: "ลูกค้า",
      revenue: "รายได้",
      projects: "โครงการ",
      salesperson: "พนักงานขาย",
      status: "สถานะ",
      actions: "การกระทำ",
      new: "ใหม่",
      viewPortfolio: "ดูพอร์ตโฟลิโอ",
    },

    distribution: {
      title: "การกระจายลูกค้าตามพนักงานขาย",
      description: "ลูกค้ากระจายอยู่ในทีมขายอย่างไร",
      salesperson: "พนักงานขาย",
      customers: "ลูกค้า",
      totalRevenue: "รายได้รวม",
      avgRevenue: "รายได้เฉลี่ย/ลูกค้า",
      actions: "การกระทำ",
      viewDetails: "ดูรายละเอียด",
    },

    messages: {
      errorLoading: "เกิดข้อผิดพลาดในการโหลดภาพรวมลูกค้า: {error}",
      noData: "ไม่มีข้อมูลลูกค้าสำหรับรอบนี้",
    },
  },

  // Salesperson Analytics Page
  salespersonAnalytics: {
    subtitle: "การวิเคราะห์ประสิทธิภาพและข้อมูลเชิงลึกของลูกค้า",
    viewCustomerPortfolio: "ดูพอร์ตลูกค้า",

    stats: {
      totalSales: "ยอดขายรวม",
      totalProjects: "โครงการทั้งหมด",
    },

    notFound: "ไม่พบพนักงานขาย",
  },

  // Customer Analytics Page
  customerAnalytics: {
    title: "พอร์ตลูกค้า",
    backToSalesperson: "กลับไปที่รายละเอียดพนักงานขาย",
    salespersonId: "รหัสพนักงานขาย: {id}",

    messages: {
      noSalespersonSelected:
        "ยังไม่ได้เลือกพนักงานขาย กรุณาเลือกพนักงานขายเพื่อดูพอร์ตลูกค้าของพวกเขา",
      errorLoading: "เกิดข้อผิดพลาดในการโหลดข้อมูลลูกค้า: {error}",
      noData: "ไม่มีข้อมูลลูกค้าสำหรับรอบนี้",
    },
  },

  // Invoice Details Modal
  invoiceModal: {
    title: "รายละเอียดค่าคอมมิชชั่น",
    period: "รอบระยะเวลา",
    excluded: "ยกเว้น",
    export: "ส่งออก Excel",
    exporting: "กำลังส่งออก...",

    tabs: {
      invoices: "ใบแจ้งหนี้",
      products: "ค่าคอมมิชชั่นสินค้า",
      creditNotes: "ใบลดหนี้",
    },

    stats: {
      totalInvoices: "จำนวนใบแจ้งหนี้",
      totalSales: "ยอดขายรวม",
      totalCommission: "ค่าคอมมิชชั่นรวม",
    },

    invoiceTable: {
      taskNumber: "เลขที่งาน",
      customerName: "ชื่อลูกค้า",
      status: "สถานะ",
      netAmount: "จำนวนเงินสุทธิ",
      totalPaid: "ชำระแล้วทั้งหมด",
      paymentDate: "วันที่ชำระ",
      commissionAmount: "ค่าคอมมิชชั่น",
    },

    productTable: {
      sku: "รหัสสินค้า",
      category: "หมวดหมู่",
      quantity: "จำนวน",
      netAmount: "จำนวนเงินสุทธิ",
      commissionRate: "อัตราค่าคอมมิชชั่น",
      commissionAmount: "ค่าคอมมิชชั่น",
    },

    creditNoteTable: {
      number: "เลขที่ใบลดหนี้",
      date: "วันที่",
      invoiceNumber: "เลขที่ใบแจ้งหนี้",
      vatInclusive: "จำนวนเงินรวมภาษี",
      preTax: "จำนวนเงินก่อนภาษี",
      commissionImpact: "ผลกระทบค่าคอมมิชชั่น",
    },

    summary: {
      title: "สรุป",
    },

    creditNotes: {
      creditNoteNumber: "เลขที่ใบลดหนี้",
      date: "วันที่",
      invoice: "ใบแจ้งหนี้",
      amount: "จำนวนเงิน",
      preTaxAmount: "จำนวนเงินก่อนภาษี",
      impact: "ผลกระทบ",
    },

    messages: {
      loading: "กำลังโหลดรายละเอียดใบแจ้งหนี้...",
      noInvoices: "ไม่พบใบแจ้งหนี้สำหรับรอบนี้",
      loadFailed: "ไม่สามารถโหลดรายละเอียดใบแจ้งหนี้ได้",
      toggleFailed: "ไม่สามารถเปลี่ยนสถานะการยกเว้นใบแจ้งหนี้ได้",
      exclusionUpdated: "อัปเดตการยกเว้นใบแจ้งหนี้แล้ว",
      exportFailed: "ไม่สามารถส่งออกข้อมูลได้",
    },
  },

  // Role Selector Component
  roleSelector: {
    previewAsRole: "ดูตัวอย่างตามบทบาท",
    viewingAs: "กำลังดูในฐานะ {roleLabel}",
    rolePreview: "ดูตัวอย่างบทบาท (สิทธิ์แอดมิน)",

    roles: {
      superAdmin: {
        label: "ซูเปอร์แอดมิน",
        description: "สิทธิ์เข้าถึงระบบเต็มรูปแบบ",
      },
      admin: {
        label: "แอดมิน",
        description: "สิทธิ์การจัดการ",
      },
      member: {
        label: "สมาชิก",
        description: "สิทธิ์ผู้ใช้งานทั่วไป",
      },
    },

    badges: {
      yourRole: "บทบาทของคุณ",
      preview: "ดูตัวอย่าง",
    },
  },

  // Preview Mode Banners
  previewMode: {
    active: "โหมดดูตัวอย่างเปิดใช้งาน",
    viewingAs: "กำลังดูในฐานะ: {roleLabel}",
    exitPreview: "ออกจากการดูตัวอย่าง",
  },

  salespersonPreview: {
    viewingAs: "โหมดดูตัวอย่าง: กำลังดูในฐานะ {salespersonName}",
    adminView: "มุมมองแอดมิน: ดูตัวอย่างการวิเคราะห์ในฐานะพนักงานขายที่เลือก",
    loading: "กำลังโหลดพนักงานขาย...",
    selectPlaceholder: "เลือกพนักงานขาย ({count} คน)",
    noSalespersons: "ไม่พบพนักงานขาย",
    allSalespersons: "พนักงานขายทั้งหมด (มุมมองแอดมิน)",
  },

  // Date/Period Selection
  datePicker: {
    pickDateRange: "เลือกช่วงวันที่",
    selectPeriod: "เลือกรอบระยะเวลา",
  },

  // Sales Components
  topProjects: {
    title: "โครงการอันดับต้น",
    noData: "ไม่มีข้อมูลโครงการ",

    table: {
      rank: "อันดับ",
      projectId: "รหัสโครงการ",
      customer: "ลูกค้า",
      salesperson: "พนักงานขาย",
      revenue: "รายได้",
      category: "หมวดหมู่",
    },
  },

  customerTable: {
    title: "พอร์ตลูกค้า",
    noData: "ไม่มีข้อมูลลูกค้า",

    table: {
      customer: "ลูกค้า",
      currentRevenue: "รายได้ปัจจุบัน",
      previousRevenue: "รายได้ก่อนหน้า",
      change: "การเปลี่ยนแปลง",
      categories: "หมวดหมู่",
      status: "สถานะ",
      projects: "โครงการ",
    },
  },

  // Auth Flow
  auth: {
    signingIn: "กำลังลงชื่อเข้าใช้...",
  },

  // Common Status Messages
  status: {
    error: "ข้อผิดพลาด!",
    success: "สำเร็จ!",
    warning: "คำเตือน",
    info: "ข้อมูล",
  },

  // Common Units
  units: {
    thb: "฿",
    percent: "%",
    items: "รายการ",
    people: "คน",
  },

  // Months (Thai Buddhist Calendar)
  months: {
    1: "มกราคม",
    2: "กุมภาพันธ์",
    3: "มีนาคม",
    4: "เมษายน",
    5: "พฤษภาคม",
    6: "มิถุนายน",
    7: "กรกฎาคม",
    8: "สิงหาคม",
    9: "กันยายน",
    10: "ตุลาคม",
    11: "พฤศจิกายน",
    12: "ธันวาคม",
  },
} as const;

// Helper function to get nested translation
export function t(
  key: string,
  replacements?: Record<string, string | number>,
): string {
  const keys = key.split(".");
  let value: any = TH_TRANSLATIONS;

  for (const k of keys) {
    value = value?.[k];
    if (value === undefined) {
      console.warn(`Translation key not found: ${key}`);
      return key;
    }
  }

  let result = String(value);

  // Replace placeholders like {format}, {error}, etc.
  if (replacements) {
    Object.entries(replacements).forEach(([placeholder, replacement]) => {
      result = result.replace(
        new RegExp(`\\{${placeholder}\\}`, "g"),
        String(replacement),
      );
    });
  }

  return result;
}
